import './index.scss';

import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/src/reducers/types';

// import Calendar from './Calendar/Calendar';
// import CalendarView from './Calendar/View/CalendarView';
import ProjectForm from './Form/Form';
import AccountView from './Form/View/AccountView';

const Account = ({ history, scrollId }) => {
  const loggedUser = useSelector((state: RootState) => state.loggedUser);
  const project = useSelector((state: RootState) => state.project);
  const accountDetailsRef = useRef<HTMLHeadingElement | null>(null);

  const [state, setState] = useState<{ scrollId: string | null }>({
    scrollId: null,
  });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      scrollId: history.location.hash ? history.location.hash.replace('#', '') : scrollId,
    }));
  }, [history.location.hash, scrollId]);

  const isAdmin = loggedUser.data.userRole < 4 || project.Selected.leadId === loggedUser.data.id;

  return (
    <React.Fragment>
      <div className={clsx('header--container', 'tw-sticky tw-top-0 tw-z-[2]')}>
        <h4
          className={clsx(
            'settingsMainTitle--container',
            'tw-bg-cfo-grey-200',
            '!tw-text-[18px] tw-text-cfo-black tw-font-brandonTextMedium',
            'tw-my-0 tw-mx-[30px] tw-pt-[30px] tw-pb-[20px] tw-px-[10px]'
          )}
          id="accountDetails"
          ref={accountDetailsRef}
        >
          Account
        </h4>
      </div>

      <div
        className={clsx(
          'settingsCardBody--container',
          'tw-scroll-smooth tw-overflow-y-auto tw-scroll-styles',
          isAdmin ? 'tw-h-[calc(100vh-180px)]' : 'tw-h-[calc(100vh-205px)]'
        )}
      >
        {isAdmin ? (
          <ProjectForm showHeader={false} scrollId={state.scrollId} />
        ) : (
          <AccountView
            projectId={project.Selected.id}
            showHeader={false}
            scrollId={state.scrollId}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Account;
